"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _categories = require("@/api/categories");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _index2 = require("@/utils/index");
var _excel = require("@/utils/excel");
var _index3 = _interopRequireDefault(require("@/components/Enabled/index.vue"));
var _index4 = _interopRequireDefault(require("@/components/Inr/index.vue"));
var _admin = require("@/store/modules/admin");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.parentId = 0;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.isSuperAdmin = false;
    this.listQuery = {
      page: 1,
      limit: 10,
      parentId: null,
      name: undefined,
      enabled: true,
      sort: 'id,ASC',
      filter: {
        name: '$contL',
        enabled: '$eq',
        parentId: '$eq'
      }
    };
    // In your component class/data
    this.uploadUrl = process.env.VUE_APP_BASE_API + 'common/upload';
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  async handleInlineUpload(response, row) {
    try {
      // 1. Update the local row icon for immediate UI feedback
      row.icon = response; // Assuming response is the URL string
      // 2. Prepare the data for the API call
      // We send the existing row data but with the new icon
      const updateData = {
        ...row,
        icon: response
      };
      // 3. Call your existing update API
      await (0, _categories.updateCategory)(row.id, updateData);
      this.$notify({
        title: 'Success',
        message: 'Icon updated successfully',
        type: 'success',
        duration: 2000
      });
    } catch (err) {
      this.$notify({
        title: 'Error',
        message: 'Failed to update icon',
        type: 'error'
      });
      // Optional: Reset icon if API fails
      row.icon = '';
    }
  }
  created() {
    this.isSuperAdmin = _admin.AdminModule.roles.toString() === 'Super Admin';
    if (this.$route.params) {
      this.parentId = parseInt(this.$route.params.parentId) || undefined;
      this.listQuery.parentId = this.parentId;
    }
    this.getList();
  }
  async getList() {
    try {
      this.listLoading = true;
      if (!this.parentId) {
        this.listQuery.parentId = true;
        this.listQuery.filter.parentId = '$isnull';
      }
      const data = await (0, _categories.getCategories)((0, _index2.getQuery)(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async updatePriority(row) {
    try {
      const data = await (0, _categories.updateCategory)(row.id, {
        priority: row.priority
      });
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
      throw error;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['id', 'fullname', 'email', 'contact', 'role'];
    const filterVal = ['id', 'fullName'];
    const data = (0, _index2.formatJson)(filterVal, this.list);
    (0, _excel.exportJson2Excel)(tHeader, data, this.$tc('route.userManagement.users.title'));
    this.downloadLoading = false;
  }
  handleDelete(data) {
    if (data) {
      this.$confirm(this.$tc('table.deleteConfirmation', undefined, {
        name: data.name
      }), this.$tc('table.delete'), {
        confirmButtonText: this.$tc('table.delete'),
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'Cancel',
        type: 'error'
      }).then(() => {
        (0, _categories.deleteCategory)(data.id).then(deleted => {
          this.getList();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$tc('table.deleteCanceled')
        });
      });
    }
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'CategoryList',
  components: {
    Pagination: _index.default,
    Enabled: _index3.default,
    Inr: _index4.default
  }
})], default_1);
var _default = exports.default = default_1;